import { PlusIcon } from '@heroicons/react/24/solid'
import React from 'react'

function DashedButton({ label, ...props }) {
  return (
    <button
      type="button"
      {...props}
      className="relative mb-10 overflow-clip block w-full rounded-full border-2 border-dashed border-gray-300 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offers-teal focus:ring-offset-2 disabled:cursor-not-allowed">
      <span className="w-full flex items-center justify-center p-3 bg-gray-100 text-sm text-gray-400 gap-2 uppercase font-semibold">
        <PlusIcon className="h-6 text-gray-400" />
        {label}
      </span>
    </button>
  )
}

export default DashedButton